import {combineReducers} from 'redux';

import members from './members-reducer';
import searchTerm from './searchTerm-reducer';
import memberType from './memberType-reducer';
import pageCount from './pageCount-reducer';
import pageNum from './pageNum-reducer';

export default combineReducers({members, searchTerm, memberType, pageCount, pageNum});